export const localeSelector = state => state.translate.locale;
